//import _ from 'lodash';
const _ = require('lodash');
const workDayLocations = _.sortBy(
	[
		{ display: 'Colton', shortDisplay: 'COL' },
		{ display: 'Huntington Beach', shortDisplay: 'HB' },
		{ display: 'Los Angeles', shortDisplay: 'LA' },
		{ display: 'Montebello', shortDisplay: 'MB' },
		{ display: 'Portland', shortDisplay: 'PDX' },
		{ display: 'Seattle', shortDisplay: 'SEA' },
		{ display: 'Tacoma', shortDisplay: 'TAC' },
		{ display: 'Ferndale', shortDisplay: 'FERN' },
		{ display: 'Eugene', shortDisplay: 'EUG' },
		{ display: 'Phoenix', shortDisplay: 'PHX' },
		{ display: 'San Diego', shortDisplay: 'SD' },
		{ display: 'Long Beach', shortDisplay: 'LB' },
	],
	'display'
);
workDayLocations.forEach((workDayLocation) => {
	workDayLocation.value = `at${workDayLocation.shortDisplay}`;
});

const isWorking = true;
const onlyShowForHrSafety = true;
const showMultiDaySelect = true;
const statuses = [
	{ display: 'Working', value: 'working', isWorking, showMultiDaySelect },
	{ display: 'Off', value: 'dayOff' },
	{ display: 'Extra Day', value: 'extraDay', isWorking },
	{ display: 'Modified Day', value: 'modifiedDay', isWorking },
	{ display: 'Cancelled ED', value: 'cancelledEd' },

	{ display: 'Swap On', value: 'swapOn', isWorking },
	{ display: 'Swap Off', value: 'swapOff' },
	{ display: 'Off', value: 'absent' },

	// new for everyone
	{ display: 'PTO', value: 'pto' },
	{ display: 'Call Out', value: 'callOut' },
	{ display: 'No Call / No Show', value: 'noCallNoShow' },

	// hr / safety
	{ display: 'FMLA', value: 'fmla', onlyShowForHrSafety, showMultiDaySelect },
	{ display: 'Workers Comp (WC)', value: 'wc', onlyShowForHrSafety, showMultiDaySelect },
	{
		display: 'Leave of Absence (LOA)',
		value: 'loa',
		onlyShowForHrSafety,
		showMultiDaySelect,
	},
];

workDayLocations.forEach(({ display, shortDisplay, value }) => {
	statuses.push({
		display: `Working at ${display} (${shortDisplay})`,
		value,
		isWorking,
		isAtLocation: true,
		shortDisplay,
		showMultiDaySelect,
	});
});

export { statuses };
/*
const statusMap = _.keyBy(statuses, 'value');
export function getStatusDisplay({ status }) {
	const o = statusMap[status] || { display : status} ;
	return o.display;
}
*/
